'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dateFns = require('date-fns');

var _reactDeviceDetect = require('react-device-detect');

var _Input = require('../../Input/Input');

var _Input2 = _interopRequireDefault(_Input);

var _Container = require('./components/Container.DateEditMode');

var _Container2 = _interopRequireDefault(_Container);

var _Content = require('./components/Content.DateEditMode');

var _Content2 = _interopRequireDefault(_Content);

var _InputContainer = require('./components/InputContainer.DateEditMode');

var _InputContainer2 = _interopRequireDefault(_InputContainer);

var _Tag = require('./components/Tag.DateEditMode');

var _Tag2 = _interopRequireDefault(_Tag);

var _Space = require('./components/Space.DateEditMode');

var _Space2 = _interopRequireDefault(_Space);

var _notifyIfDisabled = require('../lib/notifyIfDisabled.date');

var _notifyIfDisabled2 = _interopRequireDefault(_notifyIfDisabled);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components
// Libs


var DateEditMode = function (_Component) {
  _inherits(DateEditMode, _Component);

  function DateEditMode() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DateEditMode);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateEditMode.__proto__ || Object.getPrototypeOf(DateEditMode)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selected: null,
      data: null
    }, _this.onMobileFocus = function () {
      if (!_reactDeviceDetect.isMobile) return;

      _this.props.onFocus();
    }, _this.onEdit = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$blur = _ref2.blur,
          blur = _ref2$blur === undefined ? false : _ref2$blur;

      var _this$props = _this.props,
          object = _this$props.object,
          onChange = _this$props.onChange,
          disabledDates = _this$props.disabledDates;
      var data = _this.state.data;
      if (!data) return;
      var dateObject = object.toDate(data);
      if (!dateObject) return;
      if ((0, _notifyIfDisabled2.default)((0, _dateFns.format)(dateObject), disabledDates)) return;
      onChange(object.revert(data));

      if (blur && _this.input) {
        _this.input.blur();

        _this.props.onBlur();
      }
    }, _this.onKeyDown = function (e) {
      if (e.key === 'Tab') {
        var type = _this.props.object.type;
        var selected = _this.state.selected;

        if (!e.shiftKey && ((type === 'datetime' || type === 'time') && selected === 'dayPart' || type === 'date' && selected === 'year') || e.shiftKey && ((type === 'datetime' || type === 'date') && selected === 'month' || type === 'time' && selected === 'hour')) {
          _this.onEdit();

          _this.props.onBlur();

          return;
        }
      }

      e.preventDefault();

      switch (e.key) {
        case 'Escape':
          return _this.setState({
            selected: null
          });

        case 'Enter':
          return _this.onEdit({
            blur: true
          });

        case 'Tab':
          return _this.cycleSelected(!e.shiftKey);

        case 'ArrowLeft':
          return _this.cycleSelected(false);

        case 'ArrowRight':
          return _this.cycleSelected(true);

        case 'ArrowUp':
          return _this.changeSelectedValue(true, e.shiftKey);

        case 'ArrowDown':
          return _this.changeSelectedValue(false, e.shiftKey);

        case 'Backspace':
          return _this.removeSelectedValue();

        default:
          return _this.onKeyPress(e.key);
      }
    }, _this.cycleSelected = function () {
      var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var type = _this.props.object.type;
      var _this$state = _this.state,
          selected = _this$state.selected,
          data = _this$state.data;
      var newSelected = null;

      if (type === 'datetime') {
        if (selected === 'month') newSelected = next ? 'day' : 'dayPart';else if (selected === 'day') newSelected = next ? 'year' : 'month';else if (selected === 'year') newSelected = next ? 'hour' : 'day';else if (selected === 'hour') newSelected = next ? 'minutes' : 'year';else if (selected === 'minutes') newSelected = next ? 'dayPart' : 'hour';else if (selected === 'dayPart') newSelected = next ? 'month' : 'minutes';else newSelected = next ? 'month' : 'dayPart';
      } else if (type === 'date') {
        if (selected === 'month') newSelected = next ? 'day' : 'year';else if (selected === 'day') newSelected = next ? 'year' : 'month';else if (selected === 'year') newSelected = next ? 'month' : 'day';else newSelected = next ? 'month' : 'year';
      } else if (type === 'time') {
        if (selected === 'hour') newSelected = next ? 'minutes' : 'dayPart';else if (selected === 'minutes') newSelected = next ? 'dayPart' : 'hour';else if (selected === 'dayPart') newSelected = next ? 'hour' : 'minutes';else newSelected = next ? 'hour' : 'dayPart';
      }

      _this.setState({
        selected: newSelected,
        data: data ? _this.stringify(_this.specify(_this.dateify(data))) : null
      });
    }, _this.initialValue = function (type) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref3$increase = _ref3.increase,
          increase = _ref3$increase === undefined ? true : _ref3$increase,
          _ref3$year = _ref3.year,
          year = _ref3$year === undefined ? null : _ref3$year,
          _ref3$month = _ref3.month,
          month = _ref3$month === undefined ? null : _ref3$month;

      var yearValue = year || (0, _dateFns.getYear)(new Date());
      var monthValue = month ? month - 1 : 0;

      switch (type) {
        case 'month':
          return increase ? 1 : 12;

        case 'day':
          return increase ? 1 : (0, _dateFns.getDate)((0, _dateFns.lastDayOfMonth)(new Date(yearValue, monthValue)));

        case 'year':
          return (0, _dateFns.getYear)(new Date());

        case 'hour':
          return increase ? 0 : 11;

        case 'minutes':
          return increase ? 0 : 59;

        case 'dayPart':
          return increase ? 0 : 1;

        default:
          return null;
      }
    }, _this.changeSelectedValue = function () {
      var increase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var shift = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$state2 = _this.state,
          selected = _this$state2.selected,
          data = _this$state2.data;
      if (!selected || !data) return;

      var date = _this.dateify(_extends({}, data));

      var increment = shift ? 5 : 1;
      date[selected] = date[selected] === null || date[selected] === undefined ? _this.initialValue(selected, {
        increase: increase,
        month: date.month,
        year: date.year
      }) : date[selected] + (increase ? increment : -increment);

      _this.setState({
        data: _this.stringify(_this.specify(date))
      });
    }, _this.removeSelectedValue = function () {
      var _this$state3 = _this.state,
          selected = _this$state3.selected,
          data = _this$state3.data;
      if (!selected) return;

      _this.setState({
        data: _extends({}, data, _defineProperty({}, selected, null))
      });
    }, _this.specify = function (data) {
      var date = _extends({}, data);

      if (date.month !== null && (date.month < 1 || date.month > 12)) date.month = date.month > 12 ? 1 : 12;
      if (date.year !== null && date.year < 1) date.year = 1;

      if (date.day !== null) {
        var lastDay = (0, _dateFns.getDate)((0, _dateFns.lastDayOfMonth)(new Date(date.year || (0, _dateFns.getYear)(new Date()), date.month ? date.month - 1 : 0)));
        if (date.day < 1 || date.day > lastDay) date.day = date.day > lastDay ? 1 : lastDay;
      }

      if (date.hour !== null && (date.hour < 0 || date.hour > 11)) date.hour = date.hour > 11 ? 0 : 11;
      if (date.minutes !== null && (date.minutes < 0 || date.minutes > 59)) date.minutes = date.minutes > 59 ? 0 : 59;
      if (date.dayPart !== null && (date.dayPart < 0 || date.dayPart > 1)) date.dayPart = date.dayPart > 1 ? 0 : 1;
      return date;
    }, _this.dateify = function (_ref4) {
      var month = _ref4.month,
          year = _ref4.year,
          day = _ref4.day,
          hour = _ref4.hour,
          minutes = _ref4.minutes,
          dayPart = _ref4.dayPart;
      return {
        month: month ? month * 1 : null,
        year: year ? year * 1 : null,
        day: day ? day * 1 : null,
        hour: hour ? hour * 1 : null,
        minutes: minutes !== null && minutes !== undefined ? minutes * 1 : null,
        dayPart: dayPart ? dayPart === 'am' ? 0 : 1 : null
      };
    }, _this.stringify = function (_ref5) {
      var month = _ref5.month,
          year = _ref5.year,
          day = _ref5.day,
          hour = _ref5.hour,
          minutes = _ref5.minutes,
          dayPart = _ref5.dayPart;
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var date = {};
      if (month !== null) date.month = '' + (format && month < 10 ? '0' : '') + month;
      if (day !== null) date.day = '' + (format && day < 10 ? '0' : '') + day;
      if (year !== null) date.year = '' + year;
      if (hour !== null) date.hour = '' + (format && hour < 10 ? '0' : '') + hour;
      if (minutes !== null) date.minutes = '' + (format && minutes < 10 ? '0' : '') + minutes;
      if (dayPart !== null) date.dayPart = dayPart === 1 ? 'pm' : 'am';
      return _extends({}, date);
    }, _this.onKeyPress = function (key) {
      var _this$state4 = _this.state,
          selected = _this$state4.selected,
          data = _this$state4.data;
      if (!selected || !data) return;

      var date = _extends({}, data);

      var dayPartKeys = ['a', 'A', 'p', 'P'];

      if (selected === 'dayPart' && dayPartKeys.includes(key)) {
        date.dayPart = key === 'a' || key === 'A' ? 'am' : 'pm';

        _this.setState({
          data: date
        }, function () {
          if (cycle) _this.cycleSelected(true);
        });

        return;
      }

      var number = key * 1;
      var cycle = false;
      if (isNaN(number) || number < 0 || number > 9) return;

      var numericDate = _this.dateify(_extends({}, date));

      var yearValue = numericDate.year || (0, _dateFns.getYear)(new Date());
      var monthValue = numericDate.month ? numericDate.month - 1 : 0;

      switch (selected) {
        case 'month':
          {
            if (date.month === '1' && number > 2 || date.month !== '1' && number < 1) return;

            if (date.month === '1') {
              date.month = '1' + key;
            } else {
              date.month = '' + (number === 1 ? '' : '0') + key;
            }

            if (date.month.length === 2) cycle = true;
            break;
          }

        case 'day':
          {
            var lastDay = (0, _dateFns.getDate)((0, _dateFns.lastDayOfMonth)(new Date(yearValue, monthValue)));
            var firstNumber = ('' + lastDay).charAt(0) * 1;
            var lastNumber = ('' + lastDay).charAt(1) * 1;
            var fromStart = !date.day || date.day.length === 2;
            if (date.day === '' + firstNumber && number > lastNumber || fromStart && number === 0) return;
            if (fromStart) date.day = '' + (number > firstNumber ? 0 : '') + key;else date.day = '' + date.day + key;
            if (date.day !== null && date.day.length === 2) cycle = true;
            break;
          }

        case 'year':
          {
            if (!date.year || date.year.length >= 4) date.year = '';
            if (!date.year && !number) return;
            if (!date.year.length && number > 2) date.year = '201' + key;else if (!date.year.length && number === 2) date.year = '2';else date.year = date.year.length >= 4 ? key : '' + date.year + key;
            if (date.year.length >= 4) cycle = true;
            break;
          }

        case 'hour':
          {
            if (date.hour === '1' && number > 2 || date.hour !== '1' && number < 1) return;

            if (date.hour === '1') {
              date.hour = '1' + key;
            } else {
              date.hour = '' + (number === 1 ? '' : '0') + key;
            }

            if (date.hour.length === 2) cycle = true;
            break;
          }

        case 'minutes':
          {
            var _fromStart = !date.minutes || date.minutes.length === 2;

            if (_fromStart && number === 0) return;
            if (_fromStart) date.minutes = '' + (number > 5 ? 0 : '') + key;else date.minutes = '' + date.minutes + key;
            if (date.minutes.length === 2) cycle = true;
            break;
          }

        default:
          break;
      }

      _this.setState({
        data: date
      }, function () {
        if (cycle) _this.cycleSelected(true);
      });
    }, _this.onTagClick = function (tag) {
      _this.input.focus();

      _this.setState({
        selected: tag
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DateEditMode, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var editMode = prevProps.editMode,
          object = prevProps.object,
          rawValue = prevProps.rawValue;
      if (!editMode && this.props.editMode) this.setState({
        selected: object.type === 'time' ? 'hour' : 'month',
        data: object.create(rawValue)
      });
      if (editMode && !this.props.editMode && rawValue !== this.props.rawValue) this.setState({
        selected: null,
        data: null
      }, this.onEdit);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          label = _props.label,
          size = _props.size,
          editMode = _props.editMode,
          onFocus = _props.onFocus,
          placeholder = _props.placeholder,
          disabled = _props.disabled,
          rawValue = _props.rawValue,
          dateFormat = _props.dateFormat,
          object = _props.object,
          error = _props.error,
          red = _props.red;
      var _state = this.state,
          selected = _state.selected,
          data = _state.data;
      return _react2.default.createElement(_Container2.default, null, _react2.default.createElement(_InputContainer2.default, {
        onClick: this.onMobileFocus
      }, _react2.default.createElement(_Input2.default, {
        value: editMode && !_reactDeviceDetect.isMobile ? '' : dateFormat(rawValue) || '',
        onChange: function onChange() {
          return null;
        },
        postIcon: 'calendar',
        size: size,
        onFocus: onFocus,
        onKeyDown: this.onKeyDown,
        placeholder: editMode ? null : placeholder,
        disabled: disabled,
        hideCursor: editMode,
        error: error,
        innerRef: function innerRef(inputDom) {
          _this2.input = inputDom;
        },
        red: red
      }, label)), editMode && data !== null && !_reactDeviceDetect.isMobile && _react2.default.createElement(_Content2.default, {
        size: size
      }, (object.type === 'date' || object.type === 'datetime') && _react2.default.createElement(_Tag2.default, {
        tag: 'month',
        shortTag: 'm',
        selected: selected === 'month',
        onClick: function onClick(e) {
          return _this2.onTagClick('month');
        }
      }, data.month), (object.type === 'date' || object.type === 'datetime') && _react2.default.createElement(_Tag2.default, {
        tag: 'day',
        shortTag: 'd',
        selected: selected === 'day',
        onClick: function onClick(e) {
          return _this2.onTagClick('day');
        }
      }, data.day), (object.type === 'date' || object.type === 'datetime') && _react2.default.createElement(_Tag2.default, {
        tag: 'year',
        shortTag: 'y',
        selected: selected === 'year',
        onClick: function onClick(e) {
          return _this2.onTagClick('year');
        }
      }, data.year), object.type === 'datetime' && _react2.default.createElement(_Space2.default, null), (object.type === 'time' || object.type === 'datetime') && _react2.default.createElement(_Tag2.default, {
        tag: 'hour',
        shortTag: 'h',
        selected: selected === 'hour',
        onClick: function onClick(e) {
          return _this2.onTagClick('hour');
        }
      }, data.hour), (object.type === 'time' || object.type === 'datetime') && _react2.default.createElement(_Tag2.default, {
        tag: 'minutes',
        shortTag: 'm',
        selected: selected === 'minutes',
        onClick: function onClick(e) {
          return _this2.onTagClick('minutes');
        }
      }, data.minutes), (object.type === 'time' || object.type === 'datetime') && _react2.default.createElement(_Tag2.default, {
        tag: 'period',
        shortTag: 'p',
        selected: selected === 'dayPart',
        onClick: function onClick(e) {
          return _this2.onTagClick('dayPart');
        }
      }, data.dayPart)));
    }
  }]);

  return DateEditMode;
}(_react.Component);

DateEditMode.propTypes = {
  object: _propTypes2.default.object,
  label: _propTypes2.default.node,
  size: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  editMode: _propTypes2.default.bool,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  rawValue: _propTypes2.default.string,
  dateFormat: _propTypes2.default.func,
  disabledDates: _propTypes2.default.array,
  error: _propTypes2.default.bool,
  red: _propTypes2.default.bool
};
DateEditMode.defaultProps = {
  dateFormat: function dateFormat(val) {
    return val;
  },
  error: false,
  red: false
};
exports.default = DateEditMode;